<template>
	<div v-bind="$attrs" class="break-words">
		<span v-for="(relation, indx) in relations.slice(0, 3)" :key="`display-relation${indx}`">
			<display-item-relation :relation="relation" />
		</span>
		<span v-if="relations.length > 3">
			<el-collapse class="simplify-collapse">
				<el-collapse-item :title="$t('More')" name="1">
					<div v-for="(relation, indx) in relations.slice(3, relations.length + 1)" :key="`display-relation${indx}`">
						<display-item-relation :relation="relation" />
					</div>
				</el-collapse-item>
			</el-collapse>
		</span>
	</div>
</template>

<script>
import DisplayItemRelation from "../display-item-relation/DisplayItemRelation";
import { Tooltip } from "element-ui";

export default {
	components: {
		DisplayItemRelation,
		"el-tooltip": Tooltip
	},
	name: "DisplayRelations",
	props: {
		relations: {
			type: Array,
			default: () => []
		}
	}
};
</script>
<style lang="scss">
.simplify-collapse {
	border: none;
	.el-collapse-item__header {
		background: #fff;
		width: fit-content;
		border: none;
	}
}
</style>
